<template>
  <div class="section fp-section" data-anchor="first-section">
    <!-- Hero Area -->
    <Loading :loaded="loaded"></Loading>
    <div class="home" v-if="slides && slides.length">
      <VueSlickCarousel :autoplay="true" :infinite="true"   :autoplaySpeed="5000" :arrows="false" :dots="true"
      :dotsClass="'hero-pagination-dots'"
                        :cssEase="'ease-in-out'"
                        :lazyLoad="'ondemand'"
      :appendDots="'#hero-pagination'">
        <div v-for="slide in slides" v-bind:key="'slide-'+slide.id">
          <SliderItem :slide="slide"></SliderItem>
        </div>
      </VueSlickCarousel>
    </div>
  </div>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import SliderItem from './SliderItem'
import Loading from './Loading'
export default {
  name: 'Slider',
  components: {
    Loading,
    VueSlickCarousel,
    SliderItem},
  data () {
    return {
      loaded: false,
      slides: []
    }
  },
  mounted () {
    this.getSlides()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getSlides()
    })
  },
  methods: {
    getSlides () {
      this.axios.get(this.$host + 'slides').then(resp => {
        const self = this
        self.loaded = true

        this.slides = resp.data.data
      }).catch(() => {
        this.loaded = true
      })
    }
  }
}

</script>

<style scoped>
.hero-single-slide {
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center center;
}

</style>



// WEBPACK FOOTER //
// src/components/Slider.vue